(function () {
  var threshold = 200; // px antes de entrar na tela
  var ticking = false;
  var videos = Array.prototype.slice.call(document.querySelectorAll('.card-video'));

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top <= (window.innerHeight + threshold) && r.bottom >= -threshold;
  }

  function loadVideo(video) {
    if (video.dataset.loaded === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); });
    video.load();
    video.dataset.loaded = 'true';
    if (video.dataset.autoplay === 'true') {
      var p = video.play();
      if (p && p.catch) p.catch(function () {}); // ignora bloqueios de autoplay
    }
  }

  function check() {
    videos.forEach(function (v) {
      if (v.dataset.loaded !== 'true' && inViewport(v)) loadVideo(v);
    });
    // remove listeners quando terminar
    if (videos.every(function (v) { return v.dataset.loaded === 'true'; })) {
      window.removeEventListener('scroll', onScroll, { passive: true });
      window.removeEventListener('resize', onScroll);
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(check);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();